import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AnimationItem } from 'lottie-web';
import card1Lottie from '../../assets/anim/card1.json';
import card2Lottie from '../../assets/anim/card2.json';
import card3Lottie from '../../assets/anim/card3.json';

@Injectable({
  providedIn: 'root'
})
export class AnimationsService {
  private animationItems: Map<string, AnimationItem> = new Map();
  private currentAnimation$ = new BehaviorSubject<string>('');
  private animationJsonCache: Map<string, Observable<any>> = new Map();
  private bundledAnimations: Record<string, any> = {
    card1: card1Lottie,
    card2: card2Lottie,
    card3: card3Lottie
  };

  constructor() {}

  loadAnimationJson(name: string): Observable<any> {
    const existing = this.animationJsonCache.get(name);
    if (existing) return existing;

    const bundled = this.bundledAnimations[name];
    const bundled$ = of(bundled).pipe(
      shareReplay({ bufferSize: 1, refCount: false })
    );
    this.animationJsonCache.set(name, bundled$);
    return bundled$;
  }

  registerAnimation(name: string, animationItem: AnimationItem): void {
    this.animationItems.set(name, animationItem);
  }

  playAnimation(name: string): void {
    // Stop current animation if any
    const current = this.currentAnimation$.value;
    if (current && this.animationItems.has(current)) {
      this.animationItems.get(current)?.stop();
    }

    // Play new animation
    const animation = this.animationItems.get(name);
    if (animation) {
      animation.play();
      this.currentAnimation$.next(name);
    }
  }

  getCurrentAnimation(): Observable<string> {
    return this.currentAnimation$.asObservable();
  }
}